import React, { memo, useState, useEffect } from 'react';
import s from './DataBar.scss';
import { getPercentageValue } from '../../utils/computation';

const DataBar = ({ color, name, ws, wsc = null, ttl_seat }) => {
  let firstBarWidth = getPercentageValue(ws, ttl_seat);
  let secondBarWidth = getPercentageValue(wsc, ttl_seat);
  firstBarWidth = isNaN(firstBarWidth) ? 0 : firstBarWidth;
  secondBarWidth = isNaN(secondBarWidth) ? 0 : secondBarWidth;
  const [width1, setWidth1] = useState(0);
  const [width2, setWidth2] = useState(0);

  // Counter state for the animated value
  const [currentWSCount, setCurrentWSCount] = useState(0);

  // Function to animate number incrementing from 0 to target
  const animateCounter = (start, end, func, duration = 1000) => {
    const stepTime = 10;
    const totalSteps = duration / stepTime;
    const increment = (end - start) / totalSteps;

    let current = start;
    const intervalId = setInterval(() => {
      current += increment;
      if (current >= end) {
        clearInterval(intervalId);
        func(end);
      } else {
        func(Math.floor(current));
      }
    }, 0);
  };

  useEffect(
    () => {
      setTimeout(() => {
        const target = wsc !== null ? wsc : ws;
        animateCounter(currentWSCount, target, setCurrentWSCount);
        animateCounter(width1, firstBarWidth, setWidth1);
        animateCounter(width2, secondBarWidth, setWidth2);
      }, 100);
    },
    [ws, wsc],
  );

  return (
    <div className={s.bar}>
      <div className={s.partyName} style={{ color }}>
        {name}
      </div>
      <div className={s.barWrapper}>
        {ws > 0 && (
          <div
            className={`${s.bars}`}
            style={{ backgroundColor: color, width: `${width1}%` }}
          />
        )}
        {wsc > 0 &&
          width2 > 0 && (
            <div
              className={`${s.bars} ${s.secondBar}`}
              style={{
                backgroundColor: color,
                width: `${width2}%`,
              }}
            />
          )}
      </div>
      {wsc != null &&
        wsc === '-' && (
          <div className={s.range} style={{ color }}>
            {wsc}
          </div>
        )}
      {wsc != null &&
        wsc !== '-' &&
        (ws === wsc ? (
          <div className={s.range} style={{ color }}>{`${
            isNaN(ws) ? 0 : ws
          }`}</div>
        ) : (
          <div className={s.range} style={{ color }}>
            {`${isNaN(ws) ? 0 : ws} - ${isNaN(wsc) ? 0 : wsc}`}
          </div>
        ))}
      {wsc == null && (
        <div className={s.range} style={{ color }}>
          {isNaN(currentWSCount) ? 0 : currentWSCount}
        </div>
      )}
    </div>
  );
};

export default memo(DataBar);
